// Detect click on START CHATTING
document.addEventListener("click", function (e) {
  var target = e.target;

  // Make sure click is from a link or button
  if (!(target.tagName === "A" || target.tagName === "BUTTON")) return;

  var text = target.textContent.trim().toLowerCase();

  if (text === "start chatting") {
    e.preventDefault(); // stop Shopify link navigation

    console.log("Opening SalesIQ chat...");

    // Trigger Zoho SalesIQ widget
    try {
      $zoho.salesiq.floatbutton.visible("show");
      $zoho.salesiq.floatwindow.visible("show");
    } catch (err) {
      console.error("SalesIQ is not ready yet:", err);
    }
  }
});